import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { CompanyModel } from '../../interfaces/company.interface';

@Injectable({ providedIn: 'root' })
export class CompanyContextService {
  public company: Observable<any>;

  private companySubject: BehaviorSubject<any>;

  constructor() {
    this.companySubject = new BehaviorSubject<any>(null);
    this.company = this.companySubject.asObservable();
  }

  public getCurrentCompany(): CompanyModel {
    return this.companySubject.getValue();
  }

  public setCompany(company: any) {
    this.companySubject.next(company);
  }
}
